import { FC, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useField, useFormikContext } from 'formik';
import { Box, FormLabel, InputGroup, InputRightElement, InputLeftElement, Skeleton, theme } from '@chakra-ui/react';
import ChevronDown from 'ui/components/Icons/ChevronDown';
import { formatBirthday, formatUsDate } from '../../helpers/dates';
import Calendar from '../Icons/Calendar';
import { CbInput } from '../Inputs/CbInput';
export interface CbFormikDatePickerProps {
  dateFormatCalendar?: string;
  defaultDate?: Date;
  fixedHeight?: boolean;
  id: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  name: string;
  showYearDropdown?: boolean;
}
export const CbFormikDatePicker: FC<CbFormikDatePickerProps> = ({
  defaultDate,
  isDisabled,
  ...props
}) => {
  const [selectedDate, setSelectedDate] = useState(() => defaultDate ? new Date(defaultDate) : undefined);
  const {
    setFieldValue
  } = useFormikContext();
  const [field] = useField(props.id);
  const formatDate: any = (date: Date) => props.id === 'birthday' ? formatBirthday(date) : formatUsDate(date);
  const inputValue = selectedDate ? formatDate(selectedDate) : '';
  const handleChange = (date: Date) => {
    setSelectedDate(date);
    setFieldValue(field.name, date);
  };
  if (props.isLoading) {
    return <Skeleton height="20px" marginY={3} />;
  }
  return <>
      <Box data-sentry-element="Box" data-sentry-source-file="CbFormikDatePicker.tsx">
        <FormLabel htmlFor={props.id} data-sentry-element="FormLabel" data-sentry-source-file="CbFormikDatePicker.tsx">{props.name}</FormLabel>
        <DatePicker {...field} {...props} disabled={isDisabled} dateFormatCalendar={props.dateFormatCalendar} selected={selectedDate} minDate={props.minDate} maxDate={props.maxDate} onChange={handleChange} showYearDropdown={props.showYearDropdown} fixedHeight={props.fixedHeight} customInput={<InputGroup>
              <CbInput paddingLeft={12} borderRadius={50} cursor="pointer" readOnly isDisabled={isDisabled} defaultValue={inputValue} value={inputValue} />
              <InputLeftElement cursor="pointer" zIndex={theme.zIndices.base} sx={{
          h: 'var(--chakra-sizes-10)',
          w: 'var(--chakra-sizes-10)'
        }}>
                <Calendar marginLeft={4} color="cloud.500" />
              </InputLeftElement>
              <InputRightElement cursor="pointer" zIndex={theme.zIndices.base} sx={{
          h: 'var(--chakra-sizes-10)',
          w: 'var(--chakra-sizes-10)'
        }}>
                {<ChevronDown color="cloud.500" />}
              </InputRightElement>
            </InputGroup>} data-sentry-element="DatePicker" data-sentry-source-file="CbFormikDatePicker.tsx" />
      </Box>
    </>;
};